import React from 'react';

type Props = {
  href: string,
  content: string,
  target?: string,
  dataId?: string,
  onClick?: Function,
};

function Link(props: Props) {
  const { href, content, target, dataId, onClick } = props;
  return (
    <a
      className="u__default-link"
      href={href}
      target={target}
      data-automation-id={dataId && dataId}
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {content}
    </a>
  );
}

Link.defaultProps = {
  target: '_self',
  dataId: null,
  onClick: null,
};

export default Link;
